export default {
  buttons: {
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    close: "Close",
    search: "Search",
    filter: "Filter",
    export: "Export",
    import: "Import",
    back: "Back",
    next: "Next",
    previous: "Previous",
    confirm: "Confirm",
    duplicate: "Duplicate",
    rename: "Rename",
    download: "Download",
    refresh: "Refresh",
    retry: "Retry",
    createProject: "Create project"
  },
  status: {
    draft: "Draft",
    validated: "Validated",
    deployed: "Deployed",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    pending: "Pending"
  },
  labels: {
    name: "Name",
    description: "Description",
    date: "Date",
    type: "Type",
    actions: "Actions",
    details: "Details",
    settings: "Settings",
    language: "Language",
    provider: "Provider",
    region: "Region",
    cost: "Cost",
    total: "Total",
    currency: "Currency",
    selectCurrency: "Select currency"
  },
  messages: {
    noData: "No data available",
    confirmDelete: "Are you sure you want to delete?",
    saveSuccess: "Saved successfully",
    saveError: "Error while saving",
    deleteSuccess: "Deleted successfully",
    deleteError: "Error while deleting"
  }
};
